export default __webpack_public_path__ + "static/sosy-0dd7dacafe1ee10476d07c861104834a.jpg";